import configHandler from '../../configHandler'

const ERROR_INVALID_ORG_NUMBER = 'invalidNumber'

const checkMod11 = (number, controlDigits) => {
    const sum = number.split('').reduce((carry, val, i) => {
        return carry + (val * controlDigits[i])
    }, 0)

    return (sum % 11) === 0
}

export default (input) => {
    return {
        input,
        isRequired: false,

        required: function () {
            this.isRequired = true
            return this
        },

        format: function () {
            return this.parsed()
        },

        isValid: function () {
            return this.validate().length === 0
        },

        validate: function () {
            const errors = []
            const orgNumber = this.parsed()
            if (orgNumber === null || orgNumber === '') {
                if (this.isRequired) {
                    errors.push(configHandler.errorMessages().orgNumber[ERROR_INVALID_ORG_NUMBER])
                }
                return errors
            }

            if (isNaN(parseInt(orgNumber)) || orgNumber.length !== 9) {
                errors.push(configHandler.errorMessages().orgNumber[ERROR_INVALID_ORG_NUMBER])
                return errors
            }

            if (['810305282', '046462626', '000000005'].indexOf(orgNumber) > -1) {
                return []
            }
            if (checkMod11(orgNumber, [3, 2, 7, 6, 5, 4, 3, 2, 1])) {
                return []
            }
            errors.push(configHandler.errorMessages().orgNumber[ERROR_INVALID_ORG_NUMBER])
            return errors
        },

        value: function () {
            return this.input
        },
    }
}